import { useEffect, useRef } from "react";
import "./Contact.css";

const CHANNELS = [
  {
    id: "email",
    label: "Email",
    value: "info@maneconsultancy.be",
    description: "Drop us a message anytime",
    href: "mailto:info@maneconsultancy.be",
    cta: "Reach out",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient
            id="grad-email"
            x1="0"
            y1="0"
            x2="24"
            y2="24"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#38bdf8" />
            <stop offset="60%" stopColor="#a78bfa" />
            <stop offset="100%" stopColor="#f472b6" />
          </linearGradient>
        </defs>
        <rect
          x="2"
          y="4"
          width="20"
          height="16"
          rx="2.5"
          stroke="url(#grad-email)"
          strokeWidth="1.6"
        />
        <path
          d="M2 8l10 7 10-7"
          stroke="url(#grad-email)"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "location",
    label: "Location",
    value: "Mechelen, Belgium",
    description: "Available remotely worldwide",
    href: null,
    cta: null,
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient
            id="grad-loc"
            x1="0"
            y1="0"
            x2="24"
            y2="24"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#38bdf8" />
            <stop offset="60%" stopColor="#a78bfa" />
            <stop offset="100%" stopColor="#f472b6" />
          </linearGradient>
        </defs>
        <path
          d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
          stroke="url(#grad-loc)"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
        <circle
          cx="12"
          cy="9"
          r="2.5"
          stroke="url(#grad-loc)"
          strokeWidth="1.6"
        />
      </svg>
    ),
  },
];

export function Contact() {
  const animRefs = useRef([]);

  useEffect(() => {
    const observers = [];

    animRefs.current.forEach((el) => {
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add("is-visible");
            observer.disconnect();
          }
        },
        { threshold: 0.15 },
      );

      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach((o) => o.disconnect());
  }, []);

  return (
    <section id="contact" className="contact">
      <div className="contact-bg" aria-hidden="true" />

      <div className="contact-inner">
        <header
          className="contact-header contact-anim"
          ref={(el) => (animRefs.current[0] = el)}
          style={{ "--delay": 0 }}
        >
          <span className="contact-label">Get in touch</span>
          <h2 className="contact-title">
            Let's build something{" "}
            <span className="contact-title-gradient">great together</span>
          </h2>
          <p className="contact-subtitle">
            Great ideas start with a simple hello. Tell us what you’re building,
            what inspires you or the challenges you’re tackling. We’d love to
            hear your story and we’ll make sure to bring the coffee.
          </p>
        </header>

        <div className="contact-grid">
          {CHANNELS.map((channel, index) => {
            const Inner = (
              <>
                <div className="contact-card__icon">{channel.icon}</div>
                <p className="contact-card__label">{channel.label}</p>
                <p className="contact-card__value">{channel.value}</p>
                <p className="contact-card__description">
                  {channel.description}
                </p>
                <span
                  className="contact-card__cta"
                  aria-hidden={!channel.cta || undefined}
                >
                  {channel.cta ? `${channel.cta} →` : ""}
                </span>
              </>
            );

            return channel.href ? (
              <a
                key={channel.id}
                href={channel.href}
                className="contact-card contact-anim"
                ref={(el) => (animRefs.current[index + 1] = el)}
                style={{ "--delay": index + 1 }}
              >
                {Inner}
              </a>
            ) : (
              <div
                key={channel.id}
                className="contact-card contact-card--static contact-anim"
                ref={(el) => (animRefs.current[index + 1] = el)}
                style={{ "--delay": index + 1 }}
              >
                {Inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
